export enum NetworkColors {
  META = "#0064E0",
  FACEBOOK = "#1877F2",
  INSTAGRAM = "#833AB4",
  PINTEREST = "#E60023",
  // Snapchat's actual brand yellow is #FFFC00, which is all but invisible on a white
  // card. The supplied Monitor mockup uses this deeper gold for the same reason.
  // Deliberate: do not "correct" it back to the brand value.
  SNAPCHAT = "#FFC300",
  // SNAP and SNAPCHAT are two spellings of the same network, so they share a
  // colour by design.
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  SNAP = "#FFC300",
  GOOGLE = "#34A853",
  // LinkedIn rebranded in 2019; #0077B5 is the old blue. The supplied Monitor
  // mockup uses the current one and is right.
  LINKEDIN = "#0A66C2",
  VIBE = "#6C2BD9",
  // Direct mail is not an ad network and has no brand of its own, so it takes the
  // platform's purple: it is our channel rather than somebody else's.
  DIRECT_MAIL = "#5B3DF5",
}

const FALLBACK_COLORS = [
  "#FF6D00", "#00ACC1", "#7CB342", "#D81B60", "#F4511E", "#5E35B1",
]

export const colorMapper = (series: any) => {
    if (!series) return []
    let fallbackIdx = 0

    return series.map((s: any) => {
        const name = s.name.toUpperCase()
        const mapped = NetworkColors[name as keyof typeof NetworkColors]
        return mapped ?? FALLBACK_COLORS[fallbackIdx++ % FALLBACK_COLORS.length]
    })
}
/*
    Display name for a reporting-network key.

    The analytics payload identifies networks by their lowercase key ("facebook",
    "tiktok"), which is what chart series are named after. Anything showing one to a
    reader wants the branded spelling, and title-casing does not get there on its own:
    "tiktok" becomes "Tiktok" and "linkedin" becomes "Linkedin".

    Lives beside colorMapper because it is the same job -- turning a network key into
    something presentable -- and three components had each grown their own copy of this
    map before it was pulled out (MPN-1530).
*/
const NETWORK_LABELS: Record<string, string> = {
  facebook: "Facebook",
  instagram: "Instagram",
  meta: "Meta",
  google: "Google",
  snapchat: "Snapchat",
  snap: "Snapchat",
  pinterest: "Pinterest",
  tiktok: "TikTok",
  linkedin: "LinkedIn",
  vibe: "Vibe",
  direct_mail: "Direct Mail",
  email: "Email",
  sms: "SMS",
}

export const networkLabel = (key: string | null | undefined): string => {
  if (!key) return ""
  const known = NETWORK_LABELS[key.toLowerCase()]
  if (known) return known
  // Unknown network: capitalise rather than showing a raw key, and let it through so a
  // newly added network is readable before anyone updates this map.
  return key.charAt(0).toUpperCase() + key.slice(1)
}
